import { render, staticRenderFns } from "./FullCalendar.vue?vue&type=template&id=38884b33&scoped=true"
import script from "./FullCalendar.vue?vue&type=script&lang=js"
export * from "./FullCalendar.vue?vue&type=script&lang=js"
import style0 from "./FullCalendar.vue?vue&type=style&index=0&id=38884b33&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38884b33",
  null
  
)

export default component.exports